import { useEffect, useState } from 'react';

import { SECOND } from 'utils/constants';

export const useTimer = (countdown: number, onEndTimer: () => void) => {
	const [time, setTime] = useState(countdown);

	useEffect(() => {
		let id = setTimeout(function tick() {
			setTime((prevState) => prevState - 1);
			id = setTimeout(tick, SECOND);
		}, SECOND);

		return () => {
			clearTimeout(id);
		};
	}, []);

	useEffect(() => {
		if (time === 0) onEndTimer();
	}, [onEndTimer, time]);

	return {
		time,
	};
};
